import classNames from 'classnames';
import React from 'react';
import EfButton from '../ef-button';
import EfImgVideo from '../ef-img-video';
import EfLink from '../ef-link';
import './index.scss';

export interface EfCardCommonProps {
    /**
     * 主题色
     */
    theme?: 'default' | 'white' | 'black';
    /**
     * 资源链接是否是视频
     */
    isVideo?: boolean;
    /**
     * 所有分辨率展示的资源链接
     */
    pc: string;
    /**
     * 分辨率小于等于1024px展示的资源链接
     */
    h5?: string;
    /**
     * 视频贴图-所有分辨率
     */
    poster?: string;
    /**
     * 视频贴图-分辨率小于等于1024px
     */
    posterH5?: string;
    /**
     * 标题
     */
    title?: string;
    /**
     * 描述
     */
    desc?: string;
    /**
     * 标题上的标签
     */
    label?: string;
    /**
     * 是否关闭卡片图片的点击链接
     */
    isCloseGloCardLink?: boolean;
    /**
     * 更多详情-链接
     */
    moreLink?: string;
    /**
     * 更多详情-文案
     */
    moreText?: string;
    /**
     * 购买-链接
     */
    buyLink?: string;
    /**
     * 购买-文案
     */
    buyText?: string;
    /**
     * 样式名
     */
    className?: string;
    /**
     * 埋点参数 list_name
     */
    gtm_list_name?: string;
    /**
     * 埋点参数 position buy 的position
     */
    gtm_position?: string;
}

/**
 * 维护:谢保林
 *
 * 通用卡片
 */
const EfCardCommon: React.FC<EfCardCommonProps> = ({
    theme = 'default',
    isVideo = false,
    pc,
    h5,
    poster,
    posterH5,
    title,
    desc,
    label,
    isCloseGloCardLink,
    moreLink,
    moreText,
    buyLink,
    buyText,
    className,
    gtm_list_name = 'Product Preview',
    gtm_position,
    ...reset
}) => {
    const prefixCls = `ef-card-common`;
    const classes = classNames(prefixCls, {
        [`${className}`]: className,
        [`${prefixCls}-${theme}`]: theme,
    });
    const cardHref = isCloseGloCardLink ? undefined : moreLink || buyLink;

    // 埋点--更多
    const more_gtm = [
        {
            event: 'uaEvent',
            event_name: 'select_product',
            list_name: gtm_list_name,
            product_name: title,
            button_name: moreText,
        },
    ];
    // 埋点--购买
    let buy_gtm = null;
    if (gtm_position) {
        buy_gtm = [
            {
                event: 'uaEvent',
                event_name: 'buy',
                product_name: title,
                position: gtm_position,
            },
        ];
    }
    let card_gtm = null; //图片处的埋点
    if (moreLink && cardHref === moreLink) {
        card_gtm = more_gtm;
    }
    if (buyLink && cardHref === buyLink) {
        card_gtm = buy_gtm;
    }

    return (
        <div className={classes} {...reset}>
            <EfLink href={cardHref} className={`${prefixCls}-img`} dataLayer={card_gtm}>
                <EfImgVideo isVideo={isVideo} pc={pc} h5={h5} poster={poster} posterH5={posterH5} />
            </EfLink>
            <div className={`${prefixCls}-msg`}>
                <div className={`${prefixCls}-msg-in`}>
                    {label && <div className={`${prefixCls}-label`}>{label}</div>}
                    {title && <div className={`${prefixCls}-title`}>{title}</div>}
                    {desc && <div className={`${prefixCls}-desc`}>{desc}</div>}
                    <div className={`${prefixCls}-links`}>
                        {moreLink && moreText && (
                            <EfButton href={moreLink} type="link_more" theme={theme} dataLayer={more_gtm}>
                                {moreText}
                            </EfButton>
                        )}
                        {buyLink && buyText && (
                            <EfButton href={buyLink} type="buy_now" theme={theme} dataLayer={buy_gtm}>
                                {buyText}
                            </EfButton>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EfCardCommon;
